import { render } from "./nodata.vue?vue&type=template&id=1ddda4c3&scoped=true&ts=true"
import script from "./nodata.vue?vue&type=script&lang=ts"
export * from "./nodata.vue?vue&type=script&lang=ts"

import "./nodata.vue?vue&type=style&index=0&id=1ddda4c3&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddda4c3"]])

export default __exports__